Object.defineProperty(exports, "__esModule", {
  value: true
});
var dateFormats = {
  date: 'YYYY-MM-DD',
  basic_date: 'YYYYMMDD',
  basic_date_time: 'YYYYMMDD[T]HHmmss.SSSZ',
  basic_date_time_no_millis: 'YYYYMMDD[T]HHmmssZ',
  date_time_no_millis: 'YYYY-MM-DD[T]HH:mm:ssZ',
  basic_time: 'HHmmss.SSSZ',
  basic_time_no_millis: 'HHmmssZ',
  epoch_millis: 'epoch_millis',
  epoch_second: 'epoch_second'
};
exports.default = dateFormats;